import { render } from "./customer-ar.vue?vue&type=template&id=e1b34bf2"
import script from "./customer-ar.vue?vue&type=script&lang=js"
export * from "./customer-ar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__